export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/worker.66cb38c8.worker.js");
}
